import React from "react";
import { ActivityIndicator, ScrollView, Text, View } from "react-native";
import { Button } from "react-native-elements";
import { observer, Observer } from "mobx-react";
import { theme } from "../../../../config/style-configs/theme";
import { UIText } from "../../../../config/lang-config";
import { ListRefreshButtonWeb } from "../../../../components/ListRefreshButtonWeb";
import { ThemedButton } from "../../../../components/ThemedButton";
import { ReportTimeSheetInsert } from "../ReportTimesheetInsert";

@observer
class AdminPayrollPageView extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
  }

  componentDidMount() {
    const scrollPos = this.controller.timeSheetStore.scrollPos;
    if (!scrollPos) return;
    if (!this.scrollView) return;
    return this.scrollView.scrollTo({ y: scrollPos || 0, animated: false });
  }

  render() {
    const invoicesReRunHelpItems = Array.isArray(
      UIText.adminCentreInvoicesReRunHelp
    )
      ? UIText.adminCentreInvoicesReRunHelp
      : String(UIText.adminCentreInvoicesReRunHelp || "")
          .split("\n")
          .filter(Boolean);
    const missedCompletedShiftHelpItems = Array.isArray(
      UIText.adminCentreAssignMissedCompletedShiftsHelp
    )
      ? UIText.adminCentreAssignMissedCompletedShiftsHelp
      : String(UIText.adminCentreAssignMissedCompletedShiftsHelp || "")
          .split("\n")
          .filter(Boolean);

    return (
      <View style={this.props.styles.style}>
        {this.controller.loading ? (
          <View style={this.props.styles.loading}>
            <ActivityIndicator size="large" color={theme.color} />
          </View>
        ) : (
          <ScrollView
            ref={ref => (this.scrollView = ref)}
            scrollEventThrottle={250}
            onScroll={this.controller.onScroll}
            contentContainerStyle={this.props.styles.scrollView}
          >
            <View style={this.props.styles.scrollViewContent}>
              <View style={this.props.styles.buttonContainer}>
                <Button
                  type="clear"
                  title={UIText.adminCentreInvoicesGen}
                  titleStyle={this.props.styles.buttonTitle}
                  onPress={() => {}}
                />
              </View>
              {/* Prior to #1396 Step 10: `onPress={this.controller.triggerInvoicesReRun}` */}
              <View style={this.props.styles.buttonContainer}>
                <ThemedButton
                  style={this.props.styles.button}
                  title={UIText.adminCentreInvoicesReRun}
                  onPress={this.controller.triggerPendingPayrollProcessingReRun}
                />
              </View>
              <View style={this.props.styles.buttonReminder}>
                {invoicesReRunHelpItems.map((item, index) => (
                  <View
                    key={`adminCentreInvoicesReRunHelp-${index}`}
                    style={this.props.styles.buttonReminderListItem}
                  >
                    <Text
                      style={this.props.styles.buttonReminderNumber}
                    >{`${index + 1}.`}</Text>
                    <Text style={this.props.styles.buttonReminderText}>
                      {item}
                    </Text>
                  </View>
                ))}
              </View>
              <View style={this.props.styles.buttonContainer}>
                <ThemedButton
                  style={this.props.styles.button}
                  title={UIText.adminCentreAssignMissedCompletedShifts}
                  onPress={
                    this.controller.triggerMissedCompletedShiftAssignment
                  }
                />
              </View>
              <View style={this.props.styles.buttonReminder}>
                {missedCompletedShiftHelpItems.map((item, index) => (
                  <View
                    key={`adminCentreAssignMissedCompletedShiftsHelp-${index}`}
                    style={this.props.styles.buttonReminderListItem}
                  >
                    <Text
                      style={this.props.styles.buttonReminderNumber}
                    >{`${index + 1}.`}</Text>
                    <Text style={this.props.styles.buttonReminderText}>
                      {item}
                    </Text>
                  </View>
                ))}
              </View>
              {/* TODO(#1396 Step 10): keep the manual Timesheet Generation
                  controls disabled. Real-time Shift assignment is the supported
                  path; reintroduce only as a targeted backfill tool if needed. */}
              {/*
              <View style={this.props.styles.buttonContainer}>
                <Button
                  type="clear"
                  title={UIText.adminCentreTimesheetGen}
                  titleStyle={this.props.styles.buttonTitle}
                  onPress={() => {}}
                />
              </View>
              <View style={this.props.styles.buttonContainer}>
                <ThemedButton
                  style={this.props.styles.button}
                  title={UIText.adminCentreTimesheetGenTrigger}
                  onPress={this.controller.triggerTimesheetGeneration}
                />
              </View>
              */}
              <View style={this.props.styles.buttonContainer}>
                <Button
                  type="clear"
                  title={UIText.adminCentreTimeSheets}
                  titleStyle={this.props.styles.buttonTitle}
                  onPress={() => {}}
                />
              </View>
              <View style={this.props.styles.buttonContainer}>
                <ThemedButton
                  icon="expand-less"
                  style={this.props.styles.button}
                  title={UIText.collapseAll}
                  onPress={this.controller.collapseAll}
                />
                <ThemedButton
                  icon="expand-more"
                  style={this.props.styles.button}
                  title={UIText.uncollapseAll}
                  onPress={this.controller.uncollapseAll}
                />
                <ListRefreshButtonWeb onRefresh={this.controller.onRefresh} />
              </View>
              {this.controller.careReceiverGroups.map(group => (
                <Observer key={group.id}>
                  {() => (
                    <View
                      style={{
                        ...this.props.styles.scrollViewCollapsibleCards,
                        paddingVertical: 5
                      }}
                    >
                      <ReportTimeSheetInsert
                        groupId={group.id}
                        group={group}
                        state={this.controller.getTimeSheetState(group.id)}
                        caregiverFilter={this.controller.timeSheetMemberFilter}
                        collapsibleTitle={this.controller.getCollapsibleTitle(
                          group
                        )}
                        showCollapsible={true}
                        handleCollapse={() =>
                          this.controller.handleCollapse(group.id)
                        }
                        collapsed={this.controller.collapsible[group.id]}
                      />
                    </View>
                  )}
                </Observer>
              ))}
              {!this.controller.noMoreNext &&
                (this.controller.paging ? (
                  <ActivityIndicator
                    size={24}
                    style={{ paddingBottom: 10, minHeight: 50 }}
                    color={theme.color}
                  />
                ) : (
                  <Button
                    type="clear"
                    style={{ minHeight: 50 }}
                    title={UIText.adminLoadMore}
                    titleStyle={{ color: theme.color }}
                    onPress={this.controller.getNextPage}
                  />
                ))}
            </View>
          </ScrollView>
        )}
      </View>
    );
  }
}

export { AdminPayrollPageView };
